import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from '@picsart/rc/helpers';

type StyleProps = {
  isElementInView: boolean;
};

const useStyles = createUseStyles(
  {
    root: {
      display: 'unset',
      marginTop: Spacings.s16,
      maxHeight: 40,
      height: '100%',
    },
    wrapper: ({ isElementInView }: StyleProps) => ({
      height: isElementInView ? 'auto' : 0,
      overflow: 'hidden',
    }),
    contentContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      paddingTop: Spacings.s32,
      marginBottom: Spacings.s40,
      [mediaQuery(BreakPoints.Small)]: {
        paddingTop: Spacings.s16,
        flexDirection: 'column',
        gap: Spacings.s10,
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s8,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    contentWrapper: {
      width: '100%',
      [mediaQuery(BreakPoints.Small)]: {
        paddingBottom: Spacings.s24,
      },
    },
  },
  { name: 'templates-filters' },
);

export default useStyles;
